export const LEADS_LITERALS = {
    allBusinessTypes: 'label_leads_all_business_types',
    backToProspectingResults: 'action_leads_back_to_prospecting_results',
    businessType: 'label_leads_business_type',
    businessTypesLoadFailed: 'error_leads_business_types_load_failed',
    confirmAndEnhance: 'action_leads_confirm_and_enhance',
    company: 'label_leads_company',
    created: 'label_leads_created',
    createdRecordsTip: 'label_leads_created_records_tip',
    currentBalance: 'label_leads_current_balance',
    distanceFromOrigin: 'label_leads_distance_from_origin',
    dragPinHelp: 'label_leads_drag_pin_help',
    enhanceSelected: 'action_leads_enhance_selected',
    enhancementFailed: 'error_leads_enhancement_failed',
    enhancementFailedStatus: 'label_leads_enhancement_failed_status',
    enhancementProgress: 'label_leads_enhancement_progress',
    enhancementSubmitted: 'label_leads_enhancement_submitted',
    enhancementComplete: 'label_leads_enhancement_complete',
    failed: 'label_leads_failed',
    fields: 'label_leads_fields',
    finish: 'action_leads_finish',
    gameIntroGo: 'label_leads_game_intro_go',
    gameIntroSubtitle: 'label_leads_game_intro_subtitle',
    gameIntroTitle: 'label_leads_game_intro_title',
    gameTitle: 'label_leads_game_title',
    gamePaused: 'label_leads_game_paused',
    gameHudScore: 'label_leads_game_hud_score',
    gameHudTime: 'label_leads_game_hud_time',
    gameHudLives: 'label_leads_game_hud_lives',
    gameHudLivesAria: 'label_leads_game_hud_lives_aria',
    gameHudSoundOn: 'label_leads_game_hud_sound_on',
    gameHudSoundOff: 'label_leads_game_hud_sound_off',
    gameHudSoundToggle: 'label_leads_game_hud_sound_toggle',
    gameHudGood: 'label_leads_game_hud_good',
    gameResultDied: 'label_leads_game_result_died',
    gameResultSkipped: 'label_leads_game_result_skipped',
    gameResultScore: 'label_leads_game_result_score',
    gameResultGoodHits: 'label_leads_game_result_good_hits',
    gameResultBadHits: 'label_leads_game_result_bad_hits',
    gameResultCopy: 'label_leads_game_result_copy',
    gameResultCopying: 'label_leads_game_result_copying',
    gameResultCopiedImage: 'label_leads_game_result_copied_image',
    gameResultCopiedText: 'label_leads_game_result_copied_text',
    gameResultCopyError: 'label_leads_game_result_copy_error',
    gameResultRestart: 'label_leads_game_result_restart',
    gameItemHot: 'label_leads_game_item_hot',
    gameItemBonusName: 'label_leads_game_item_bonus_name',
    gameItemBonus: 'label_leads_game_item_bonus',
    gameActivityPhoneCall: 'label_leads_game_activity_phone_call',
    gameActivityCheckIn: 'label_leads_game_activity_check_in',
    gameActivityVideoCheckIn: 'label_leads_game_activity_video_check_in',
    gameActivityFastCheckIn: 'label_leads_game_activity_fast_check_in',
    gameActivityEmail: 'label_leads_game_activity_email',
    gameActivityVideoCall: 'label_leads_game_activity_video_call',
    gameActivityWhatsapp: 'label_leads_game_activity_whatsapp',
    gameBadSpam: 'label_leads_game_bad_spam',
    gameBadSpamSubtitle: 'label_leads_game_bad_spam_subtitle',
    gameBadUrgentMeeting: 'label_leads_game_bad_urgent_meeting',
    gameBadUrgentMeetingSubtitle: 'label_leads_game_bad_urgent_meeting_subtitle',
    gameBadGhostClient: 'label_leads_game_bad_ghost_client',
    gameBadGhostClientSubtitle: 'label_leads_game_bad_ghost_client_subtitle',
    gameBadInfiniteExcel: 'label_leads_game_bad_infinite_excel',
    gameBadInfiniteExcelSubtitle: 'label_leads_game_bad_infinite_excel_subtitle',
    gameBadMassCc: 'label_leads_game_bad_mass_cc',
    gameBadMassCcSubtitle: 'label_leads_game_bad_mass_cc_subtitle',
    gameBadSurpriseMeeting: 'label_leads_game_bad_surprise_meeting',
    gameBadSurpriseMeetingSubtitle: 'label_leads_game_bad_surprise_meeting_subtitle',
    gameBadZombieLead: 'label_leads_game_bad_zombie_lead',
    gameBadZombieLeadSubtitle: 'label_leads_game_bad_zombie_lead_subtitle',
    gameBadColdCoffee: 'label_leads_game_bad_cold_coffee',
    gameBadColdCoffeeSubtitle: 'label_leads_game_bad_cold_coffee_subtitle',
    gameBadDuplicate: 'label_leads_game_bad_duplicate',
    gameBadDuplicateSubtitle: 'label_leads_game_bad_duplicate_subtitle',
    insufficientCredits: 'error_leads_insufficient_credits',
    leadName: 'label_leads_lead_name',
    maxCost: 'label_leads_max_cost',
    maxResults: 'label_leads_max_results',
    new: 'label_leads_new',
    noCoordinatesReturned: 'error_leads_no_coordinates_returned',
    openMapProspectingTooltip: 'tooltip_leads_map_prospecting',
    pending: 'label_leads_pending',
    placeSearchPlaceholder: 'placeholder_leads_search_place',
    potentialDuplicate: 'label_leads_potential_duplicate',
    potentialDuplicates: 'label_leads_potential_duplicates',
    previewFailed: 'error_leads_preview_failed',
    previewIsFree: 'label_leads_preview_is_free',
    projectedBalance: 'label_leads_projected_balance',
    prospectFromMap: 'action_leads_prospect_from_map',
    radius: 'label_leads_radius',
    resetToMyLocation: 'action_leads_reset_to_my_location',
    reviewAndCreate: 'action_leads_review_and_create',
    reviewStatsAllFailedMiddle: 'label_leads_review_stats_all_failed_middle',
    reviewStatsAllReviewedMiddle: 'label_leads_review_stats_all_reviewed_middle',
    reviewStatsAllReviewedWithFailuresAfterCreated:
        'label_leads_review_stats_all_reviewed_with_failures_after_created',
    reviewStatsAllReviewedWithFailuresAfterCredits:
        'label_leads_review_stats_all_reviewed_with_failures_after_credits',
    reviewStatsAllReviewedWithFailuresAfterFailed:
        'label_leads_review_stats_all_reviewed_with_failures_after_failed',
    reviewStatsNoFailuresAfterCredits: 'label_leads_review_stats_no_failures_after_credits',
    reviewStatsNoFailuresLeadSuffixPlural:
        'label_leads_review_stats_no_failures_lead_suffix_plural',
    reviewStatsNoFailuresLeadSuffixSingular:
        'label_leads_review_stats_no_failures_lead_suffix_singular',
    reviewStatsWithFailuresAfterCredits: 'label_leads_review_stats_with_failures_after_credits',
    reviewStatsWithFailuresAfterFailed: 'label_leads_review_stats_with_failures_after_failed',
    reviewStatsWithFailuresAfterReady: 'label_leads_review_stats_with_failures_after_ready',
    reviewTitleAllFailedSuffixPlural: 'title_leads_review_all_failed_suffix_plural',
    reviewTitleAllFailedSuffixSingular: 'title_leads_review_all_failed_suffix_singular',
    reviewTitleAllReviewed: 'title_leads_review_all_reviewed',
    reviewTitleAllReviewedWithFailuresPrefix:
        'title_leads_review_all_reviewed_with_failures_prefix',
    reviewTitleAllReviewedWithFailuresSuffix:
        'title_leads_review_all_reviewed_with_failures_suffix',
    reviewTitleReadySuffixPlural: 'title_leads_review_ready_suffix_plural',
    reviewTitleReadySuffixSingular: 'title_leads_review_ready_suffix_singular',
    reviewTitleWithFailuresFailedSuffixPlural:
        'title_leads_review_with_failures_failed_suffix_plural',
    reviewTitleWithFailuresFailedSuffixSingular:
        'title_leads_review_with_failures_failed_suffix_singular',
    reviewTitleWithFailuresReadySuffixPlural:
        'title_leads_review_with_failures_ready_suffix_plural',
    reviewTitleWithFailuresReadySuffixSingular:
        'title_leads_review_with_failures_ready_suffix_singular',
    runProspecting: 'action_leads_run_prospecting',
    searchOrigin: 'label_leads_search_origin',
    selected: 'label_leads_selected',
    selectedLeads: 'label_leads_selected_leads',
    showPotentialDuplicates: 'label_leads_show_potential_duplicates',
    status: 'label_leads_status',
    matchQuality: 'label_leads_match_quality',
    rowAction: 'label_leads_row_action',
    tourDescription: 'label_leads_tour_description',
    useCredits: 'title_leads_use_credits',
    useCreditsCurrentBalance: 'label_leads_use_credits_current_balance',
    useCreditsEnhanceSummaryPlural: 'label_leads_use_credits_enhance_summary_plural',
    useCreditsEnhanceSummarySingular: 'label_leads_use_credits_enhance_summary_singular',
    useCreditsFailedNotChargedLine: 'label_leads_use_credits_failed_not_charged',
    useCreditsRemainingBalance: 'label_leads_use_credits_remaining_balance',
    validOriginRequired: 'error_leads_valid_origin_required',
    viewEnhancementResults: 'action_leads_view_enhancement_results',
};

const WORD_OVERRIDES = {
    cta: 'CTA',
    hvac: 'HVAC',
};

/**
 * Dev-only copy injected via `injectDebugLiterals(LEADS_DEBUG_LITERALS)`.
 * Keys are the CMS sentence ids (same as production). Comments describe UI placement for PM/localization.
 */
const SENTENCE_OVERRIDES = {
    // label_leads_all_business_types — Preview filters: first option in the business-type category group (LeadsQuickFilters / index categoryOptions).
    label_leads_all_business_types: 'Any business type',

    // action_leads_back_to_prospecting_results — Review step footer: secondary button returning to preview/map (index renderReview footer).
    action_leads_back_to_prospecting_results: 'Back to prospecting results',

    // label_leads_business_type — Preview filters: category group label and field label (LeadsQuickFilters, index categoryOptions).
    label_leads_business_type: 'Business type',

    // error_leads_business_types_load_failed — Preview step: error when business-type API fails; also fallback in modal error banner (index).
    error_leads_business_types_load_failed:
        'Business types could not be loaded. Check your connection and try again.',

    // action_leads_confirm_and_enhance — Use-credits confirm modal: primary confirm button (index confirmCredits modal).
    action_leads_confirm_and_enhance: 'Confirm and enhance',

    // label_leads_company — Review queue grid: Company column header (ReviewQueue).
    label_leads_company: 'Company',

    // label_leads_created — Review queue grid: status tag when account was created from a lead (ReviewQueue tagCell).
    label_leads_created: 'Created',

    // label_leads_created_records_tip — Review step: caption under summary when there are created rows (index renderReview).
    label_leads_created_records_tip:
        'Review each enriched lead and create accounts one at a time from the row actions.',

    // label_leads_current_balance — Preview footer: credits summary row label before enhance (index renderPreview footer).
    label_leads_current_balance: 'Current balance',

    // label_leads_distance_from_origin — Preview list row: distance line under lead name (LeadPreviewRow).
    label_leads_distance_from_origin: 'Distance from origin',

    // label_leads_drag_pin_help — Map overlay help text below the map (LeadsMap; supports Markdown).
    label_leads_drag_pin_help: 'Drag the pin to change the search origin.',

    // action_leads_enhance_selected — Preview footer: primary button opening use-credits confirm (index renderPreview footer).
    action_leads_enhance_selected: 'Enhance selected',

    // error_leads_enhancement_failed — Enrichment error toast/message; failed row error text in review queue (index, ReviewQueue company cell).
    error_leads_enhancement_failed: 'We could not enhance the selected leads.',

    // label_leads_enhancement_failed_status — Review queue: status tag label for failed enrichment rows (ReviewQueue).
    label_leads_enhancement_failed_status: 'Enhancement failed',

    // label_leads_enhancement_progress — Enriching step section title (index renderEnriching); Lead Pop HUD subtitle (leadPopLiterals game.subtitle).
    label_leads_enhancement_progress: 'Enhancement in progress',

    // label_leads_enhancement_submitted — Enriching step: progress label before count (index renderEnriching).
    label_leads_enhancement_submitted: 'Submitted',

    // label_leads_enhancement_complete — Lead Pop result overlay title when enrichment finishes (GameResult; leadPopLiterals result.finished).
    label_leads_enhancement_complete: 'Enhancement complete',

    // label_leads_failed — Review queue: status tag for failed rows (ReviewQueue; key via LEADS_LITERALS.failed).
    label_leads_failed: 'Failed',

    // label_leads_fields — Review queue: suffix in match-quality cell, e.g. "85% fields" (ReviewQueue).
    label_leads_fields: 'fields',

    // action_leads_finish — Review step footer: primary button to close modal (index renderReview footer).
    action_leads_finish: 'Finish',

    // label_leads_game_intro_go — Lead Pop start banner: “Go” phase after countdown (GameStartBanner; leadPopLiterals game.intro.go).
    label_leads_game_intro_go: 'Go',

    // label_leads_game_intro_subtitle — Lead Pop start banner body (GameStartBanner; leadPopLiterals game.intro.subtitle).
    label_leads_game_intro_subtitle:
        'Enjoy the wait while we run prospecting and score as many points as you can. We will notify you when we are done.\n\n' +
        '\n\nRemember: share your score with your colleagues!',

    // label_leads_game_intro_title — Lead Pop start banner title (GameStartBanner; leadPopLiterals game.intro.title).
    label_leads_game_intro_title: "Let's prospect!",

    // label_leads_game_title — Lead Pop HUD wordmark and result card kicker (GameTitleMark, GameResult; leadPopLiterals game.title).
    label_leads_game_title: 'Lead Pop',

    // label_leads_game_paused — Lead Pop overlay when the round is paused (LeadPopGame; leadPopLiterals game.paused).
    label_leads_game_paused: 'Paused',

    // label_leads_game_sound_hint — Lead Pop: one-shot hint to enable sound after first score while muted.
    label_leads_game_sound_hint: 'Turn on sound for the full experience',

    // label_leads_game_hud_score — Lead Pop HUD: score stat label (GameHud; leadPopLiterals hud.score).
    label_leads_game_hud_score: 'Score',

    // label_leads_game_hud_time — Lead Pop HUD: timer stat label when useDurationLimit is on (GameHud; leadPopLiterals hud.time).
    label_leads_game_hud_time: 'Time',

    // label_leads_game_hud_lives — Lead Pop HUD: lives stat label (GameHud; leadPopLiterals hud.lives).
    label_leads_game_hud_lives: 'Lives',

    // label_leads_game_hud_lives_aria — Lead Pop HUD: accessible lives count; %1$s = remaining lives (GameHud; leadPopLiterals hud.livesAria).
    label_leads_game_hud_lives_aria: '%1$s lives',

    // label_leads_game_hud_sound_on — Lead Pop HUD: sound toggle tooltip when audio is on (GameHud; leadPopLiterals hud.soundOn).
    label_leads_game_hud_sound_on: 'Sound on',

    // label_leads_game_hud_sound_off — Lead Pop HUD: sound toggle tooltip when muted (GameHud; leadPopLiterals hud.soundOff).
    label_leads_game_hud_sound_off: 'Sound off',

    // label_leads_game_hud_sound_toggle — Lead Pop HUD: sound button aria-label (GameHud; leadPopLiterals hud.soundToggle).
    label_leads_game_hud_sound_toggle: 'Toggle sound',

    // label_leads_game_hud_good — Lead Pop HUD: reserved good-hits label (leadPopLiterals hud.good; not shown in current UI).
    label_leads_game_hud_good: 'Leads',

    // label_leads_game_result_died — Lead Pop result overlay title when the player runs out of lives (GameResult; leadPopLiterals result.died).
    label_leads_game_result_died: 'Game over',

    // label_leads_game_result_skipped — Lead Pop result overlay title when the round is skipped (GameResult; leadPopLiterals result.skipped).
    label_leads_game_result_skipped: 'Game skipped',

    // label_leads_game_result_score — Lead Pop result card: main score row label (GameResult; leadPopLiterals result.score).
    label_leads_game_result_score: 'Score',

    // label_leads_game_result_good_hits — Lead Pop result card: successful taps stat label (GameResult; leadPopLiterals result.goodHits).
    label_leads_game_result_good_hits: 'Leads caught',

    // label_leads_game_result_bad_hits — Lead Pop result card: penalty taps stat label (GameResult; leadPopLiterals result.badHits).
    label_leads_game_result_bad_hits: 'Mistakes',

    // label_leads_game_result_copy — Lead Pop result: copy-to-clipboard button default label (GameResult; leadPopLiterals result.copy).
    label_leads_game_result_copy: 'Copy result',

    // label_leads_game_result_copying — Lead Pop result: copy button while clipboard write is in progress (GameResult; leadPopLiterals result.copying).
    label_leads_game_result_copying: 'Copying…',

    // label_leads_game_result_copied_image — Lead Pop result: copy success when PNG lands on clipboard (GameResult; leadPopLiterals result.copiedImage).
    label_leads_game_result_copied_image: 'Image copied',

    // label_leads_game_result_copied_text — Lead Pop result: copy success fallback plain-text mode (GameResult; leadPopLiterals result.copiedText).
    label_leads_game_result_copied_text: 'Text copied',

    // label_leads_game_result_copy_error — Lead Pop result: copy failure message (GameResult; leadPopLiterals result.copyError).
    label_leads_game_result_copy_error: 'Could not copy',

    // label_leads_game_result_restart — Lead Pop result: primary action in standalone/demo mode (GameResult; leadPopLiterals result.restart).
    label_leads_game_result_restart: 'Play again',

    // label_leads_game_item_hot — Lead Pop floating card: hot-lead item title (FloatingItem; leadPopLiterals items.hot).
    label_leads_game_item_hot: 'Hot lead',

    // label_leads_game_item_bonus_name — Lead Pop floating card: bonus item title (FloatingItem; leadPopLiterals items.bonusName).
    label_leads_game_item_bonus_name: 'Bonus',

    // label_leads_game_item_bonus — Lead Pop floating card: bonus item subtitle / streak copy (FloatingItem; leadPopLiterals items.bonus).
    label_leads_game_item_bonus: 'Sales streak',

    // label_leads_game_activity_phone_call — Lead Pop activity card: phone-call type label (FloatingItem; leadPopLiterals activities.phoneCall).
    label_leads_game_activity_phone_call: 'Phone calls',

    // label_leads_game_activity_check_in — Lead Pop activity card: check-in type label (FloatingItem; leadPopLiterals activities.checkIn).
    label_leads_game_activity_check_in: 'Check-in',

    // label_leads_game_activity_video_check_in — Lead Pop activity card: video check-in label (FloatingItem; leadPopLiterals activities.videoCheckIn).
    label_leads_game_activity_video_check_in: 'Video Check-in',

    // label_leads_game_activity_fast_check_in — Lead Pop activity card: fast check-in label (FloatingItem; leadPopLiterals activities.fastCheckIn).
    label_leads_game_activity_fast_check_in: 'Fast Check-in',

    // label_leads_game_activity_email — Lead Pop activity card: email type label (FloatingItem; leadPopLiterals activities.email).
    label_leads_game_activity_email: 'Email',

    // label_leads_game_activity_video_call — Lead Pop activity card: video-call label (FloatingItem; leadPopLiterals activities.videoCall).
    label_leads_game_activity_video_call: 'Video call',

    // label_leads_game_activity_whatsapp — Lead Pop activity card: WhatsApp label (FloatingItem; leadPopLiterals activities.whatsapp).
    label_leads_game_activity_whatsapp: 'Whatsapp',

    // label_leads_game_bad_spam — Lead Pop distraction card: SPAM title (FloatingItem; leadPopLiterals badItems.spam).
    label_leads_game_bad_spam: 'SPAM',

    // label_leads_game_bad_spam_subtitle — Lead Pop distraction card: SPAM subtitle (FloatingItem; leadPopLiterals badItems.spam.subtitle).
    label_leads_game_bad_spam_subtitle: 'Inbox overflowing',

    // label_leads_game_bad_urgent_meeting — Lead Pop distraction card: urgent meeting title (FloatingItem; leadPopLiterals badItems.urgentMeeting).
    label_leads_game_bad_urgent_meeting: 'Urgent meeting',

    // label_leads_game_bad_urgent_meeting_subtitle — Lead Pop distraction card: urgent meeting subtitle (FloatingItem; leadPopLiterals badItems.urgentMeeting.subtitle).
    label_leads_game_bad_urgent_meeting_subtitle: 'Got 5 minutes?',

    // label_leads_game_bad_ghost_client — Lead Pop distraction card: ghost client title (FloatingItem; leadPopLiterals badItems.ghostClient).
    label_leads_game_bad_ghost_client: 'Ghost client',

    // label_leads_game_bad_ghost_client_subtitle — Lead Pop distraction card: ghost client subtitle (FloatingItem; leadPopLiterals badItems.ghostClient.subtitle).
    label_leads_game_bad_ghost_client_subtitle: 'Reads but never replies',

    // label_leads_game_bad_infinite_excel — Lead Pop distraction card: endless spreadsheet title (FloatingItem; leadPopLiterals badItems.infiniteExcel).
    label_leads_game_bad_infinite_excel: 'Endless spreadsheet',

    // label_leads_game_bad_infinite_excel_subtitle — Lead Pop distraction card: endless spreadsheet subtitle (FloatingItem; leadPopLiterals badItems.infiniteExcel.subtitle).
    label_leads_game_bad_infinite_excel_subtitle: 'Just one more column',

    // label_leads_game_bad_mass_cc — Lead Pop distraction card: mass CC title (FloatingItem; leadPopLiterals badItems.massCc).
    label_leads_game_bad_mass_cc: 'Mass CC',

    // label_leads_game_bad_mass_cc_subtitle — Lead Pop distraction card: mass CC subtitle (FloatingItem; leadPopLiterals badItems.massCc.subtitle).
    label_leads_game_bad_mass_cc_subtitle: '47 people copied',

    // label_leads_game_bad_surprise_meeting — Lead Pop distraction card: surprise meeting title (FloatingItem; leadPopLiterals badItems.surpriseMeeting).
    label_leads_game_bad_surprise_meeting: 'Surprise meeting',

    // label_leads_game_bad_surprise_meeting_subtitle — Lead Pop distraction card: surprise meeting subtitle (FloatingItem; leadPopLiterals badItems.surpriseMeeting.subtitle).
    label_leads_game_bad_surprise_meeting_subtitle: 'What are we discussing?',

    // label_leads_game_bad_zombie_lead — Lead Pop distraction card: zombie lead title (FloatingItem; leadPopLiterals badItems.zombieLead).
    label_leads_game_bad_zombie_lead: 'Zombie lead',

    // label_leads_game_bad_zombie_lead_subtitle — Lead Pop distraction card: zombie lead subtitle (FloatingItem; leadPopLiterals badItems.zombieLead.subtitle).
    label_leads_game_bad_zombie_lead_subtitle: 'Still interested?',

    // label_leads_game_bad_cold_coffee — Lead Pop distraction card: cold coffee title (FloatingItem; leadPopLiterals badItems.coldCoffee).
    label_leads_game_bad_cold_coffee: 'Cold coffee',

    // label_leads_game_bad_cold_coffee_subtitle — Lead Pop distraction card: cold coffee subtitle (FloatingItem; leadPopLiterals badItems.coldCoffee.subtitle).
    label_leads_game_bad_cold_coffee_subtitle: 'The machine again',

    // label_leads_game_bad_duplicate — Lead Pop distraction card: duplicate title (FloatingItem; leadPopLiterals badItems.duplicate).
    label_leads_game_bad_duplicate: 'Duplicate',

    // label_leads_game_bad_duplicate_subtitle — Lead Pop distraction card: duplicate subtitle (FloatingItem; leadPopLiterals badItems.duplicate.subtitle).
    label_leads_game_bad_duplicate_subtitle: 'We already have this',

    // error_leads_insufficient_credits — Preview footer: caption when selected leads cost exceeds balance (index renderPreview footer).
    error_leads_insufficient_credits: 'You do not have enough credits for the selected leads.',

    // label_leads_lead_name — Preview list: column header (LeadList).
    label_leads_lead_name: 'Lead name',

    // label_leads_max_cost — Preview footer: credits summary row for selection cost (index renderPreview footer).
    label_leads_max_cost: 'Max cost',

    // label_leads_max_results — Preview filters: max-results field label (LeadsQuickFilters).
    label_leads_max_results: 'Max results',

    // label_leads_new — Preview list: tab title for non-duplicate bucket (index duplicateBucketTabs).
    label_leads_new: 'New',

    // error_leads_no_coordinates_returned — Preview: error when prospecting API returns no geocoded leads (index runPreview).
    error_leads_no_coordinates_returned: 'No valid coordinates were returned for this search.',

    // tooltip_leads_map_prospecting — Accounts menu: tooltip on map-prospecting icon button (companies/Menu.jsx).
    tooltip_leads_map_prospecting:
        'Find nearby businesses on the map, enrich them, and create accounts.',

    // label_leads_pending — Review queue: status tag for leads ready to review (ReviewQueue).
    label_leads_pending: 'Pending review',

    // placeholder_leads_search_place — Map controls: Google place search input placeholder (PlaceSearch).
    placeholder_leads_search_place: 'Search a place or address',

    // label_leads_potential_duplicate — Preview list row badge; review queue company cell suffix (LeadPreviewRow, ReviewQueue).
    label_leads_potential_duplicate: 'Potential duplicate',

    // label_leads_potential_duplicates — Preview list: tab title for duplicate bucket (index duplicateBucketTabs).
    label_leads_potential_duplicates: 'Potential duplicates',

    // error_leads_preview_failed — Preview: error when nearby-places request fails (index runPreview).
    error_leads_preview_failed: 'We could not load the preview.',

    // label_leads_preview_is_free — Preview footer: hint that preview does not spend credits (index renderPreview footer).
    label_leads_preview_is_free: 'Preview is free. Credits are only used when you enhance leads.',

    // label_leads_projected_balance — Preview footer: credits summary row after selection (index renderPreview footer).
    label_leads_projected_balance: 'Projected balance',

    // action_leads_prospect_from_map — Modal title; accounts header tour title (index modal, LeadsHeaderTour).
    action_leads_prospect_from_map: 'Prospect from map',

    // label_leads_radius — Preview filters: radius field label (LeadsQuickFilters).
    label_leads_radius: 'Radius',

    // action_leads_reset_to_my_location — Map: HoiPoi tooltip on recenter control (LeadsMapOriginControl / LeadsMap reference pin).
    action_leads_reset_to_my_location: 'Back to my location',

    // action_leads_review_and_create — Review queue: row action button opening account CRUD (ReviewQueue).
    action_leads_review_and_create: 'Review and create',

    // label_leads_review_stats_all_failed_middle — Review summary stats (helpers): fragment after failed count when all enrichments failed.
    label_leads_review_stats_all_failed_middle:
        ' could not be enhanced (not charged) · Remaining balance: ',

    // label_leads_review_stats_all_reviewed_middle — Review summary stats (helpers): fragment after credits used when all rows reviewed, no failures.
    label_leads_review_stats_all_reviewed_middle: ' credits used · Remaining balance: ',

    // label_leads_review_stats_all_reviewed_with_failures_after_created — Review summary stats (helpers): fragment after created-account count.
    label_leads_review_stats_all_reviewed_with_failures_after_created: ' accounts created · ',

    // label_leads_review_stats_all_reviewed_with_failures_after_credits — Review summary stats (helpers): fragment before remaining balance (all reviewed, with failures).
    label_leads_review_stats_all_reviewed_with_failures_after_credits:
        ' credits used · Remaining balance: ',

    // label_leads_review_stats_all_reviewed_with_failures_after_failed — Review summary stats (helpers): fragment after failed count (all reviewed, with failures).
    label_leads_review_stats_all_reviewed_with_failures_after_failed:
        ' could not be enhanced (not charged) · ',

    // label_leads_review_stats_no_failures_after_credits — Review summary stats (helpers): fragment before balance when some leads still pending, no failures.
    label_leads_review_stats_no_failures_after_credits: ' credits used · Remaining balance: ',

    // label_leads_review_stats_no_failures_lead_suffix_plural — Review summary stats (helpers): after ready count, plural (no failures).
    label_leads_review_stats_no_failures_lead_suffix_plural: ' enriched leads ready for review · ',

    // label_leads_review_stats_no_failures_lead_suffix_singular — Review summary stats (helpers): after ready count, singular (no failures).
    label_leads_review_stats_no_failures_lead_suffix_singular: ' enriched lead ready for review · ',

    // label_leads_review_stats_with_failures_after_credits — Review summary stats (helpers): fragment before balance when failures exist.
    label_leads_review_stats_with_failures_after_credits: ' credits used · Remaining balance: ',

    // label_leads_review_stats_with_failures_after_failed — Review summary stats (helpers): fragment after failed count (mixed ready + failed).
    label_leads_review_stats_with_failures_after_failed: ' could not be enhanced (not charged) · ',

    // label_leads_review_stats_with_failures_after_ready — Review summary stats (helpers): fragment after ready count (mixed ready + failed).
    label_leads_review_stats_with_failures_after_ready: ' companies are ready for review · ',

    // title_leads_review_all_failed_suffix_plural — Review summary title (helpers): after failed count, plural, all failed.
    title_leads_review_all_failed_suffix_plural: ' leads could not be enriched',

    // title_leads_review_all_failed_suffix_singular — Review summary title (helpers): after failed count, singular, all failed.
    title_leads_review_all_failed_suffix_singular: ' lead could not be enriched',

    // title_leads_review_all_reviewed — Review summary title (helpers): all leads reviewed, none pending/failed.
    title_leads_review_all_reviewed: 'All enriched leads have been reviewed',

    // title_leads_review_all_reviewed_with_failures_prefix — Review summary title (helpers): fixed prefix when all reviewed but some failed.
    title_leads_review_all_reviewed_with_failures_prefix: 'All enriched leads have been reviewed. ',

    // title_leads_review_all_reviewed_with_failures_suffix — Review summary title (helpers): after failed count when all reviewed.
    title_leads_review_all_reviewed_with_failures_suffix: ' could not be enriched.',

    // title_leads_review_ready_suffix_plural — Review summary title (helpers): after ready count, plural, no failures.
    title_leads_review_ready_suffix_plural: ' leads ready for review',

    // title_leads_review_ready_suffix_singular — Review summary title (helpers): after ready count, singular, no failures.
    title_leads_review_ready_suffix_singular: ' lead ready for review',

    // title_leads_review_with_failures_failed_suffix_plural — Review summary title (helpers): after failed count, plural, mixed state.
    title_leads_review_with_failures_failed_suffix_plural: ' could not be enriched.',

    // title_leads_review_with_failures_failed_suffix_singular — Review summary title (helpers): after failed count, singular, mixed state.
    title_leads_review_with_failures_failed_suffix_singular: ' could not be enriched.',

    // title_leads_review_with_failures_ready_suffix_plural — Review summary title (helpers): after ready count, plural, mixed state.
    title_leads_review_with_failures_ready_suffix_plural: ' leads ready for review. ',

    // title_leads_review_with_failures_ready_suffix_singular — Review summary title (helpers): after ready count, singular, mixed state.
    title_leads_review_with_failures_ready_suffix_singular: ' lead ready for review. ',

    // action_leads_run_prospecting — Preview footer: button to fetch nearby leads (index renderPreview footer).
    action_leads_run_prospecting: 'Run prospecting',

    // label_leads_search_origin — Map: HoiPoi tooltip on draggable search-origin pin (LeadsMap).
    label_leads_search_origin: 'Search origin',

    // label_leads_selected — Preview footer: credits summary label for selection count (index renderPreview footer).
    label_leads_selected: 'Selected',

    // label_leads_selected_leads — Reserved for selection copy if used in future UI (defined in LEADS_LITERALS).
    label_leads_selected_leads: 'Selected leads',

    // label_leads_show_potential_duplicates — Preview: checkbox label to include duplicate bucket (index renderPreview).
    label_leads_show_potential_duplicates: 'Show potential duplicates',

    // label_leads_status — Review queue: Status column header (ReviewQueue).
    label_leads_status: 'Status',

    // label_leads_match_quality — Review queue: Match quality column header (ReviewQueue).
    label_leads_match_quality: 'Match quality',

    // label_leads_row_action — Review queue: Actions column header (ReviewQueue).
    label_leads_row_action: 'Action',

    // label_leads_tour_description — Accounts header product tour body (LeadsHeaderTour); Lead Pop board hint (leadPopLiterals game.hint).
    label_leads_tour_description:
        'Find nearby businesses on the map, enrich them, and create accounts faster.',

    // title_leads_use_credits — Confirm modal title before enrichment (index confirmCredits modal).
    title_leads_use_credits: 'Use credits',

    // label_leads_use_credits_current_balance — Confirm modal block 1: current balance line; %1$s = balance (Markdown bold supported).
    label_leads_use_credits_current_balance: 'Current balance: **%1$s** credits',

    // label_leads_use_credits_enhance_summary_plural — Confirm modal block 2: plural; %1$s = selected count, %2$s = max credits.
    label_leads_use_credits_enhance_summary_plural:
        'Enhancing **%1$s** selected leads will use **up to %2$s** credits.',

    // label_leads_use_credits_enhance_summary_singular — Confirm modal block 2: singular; %1$s = max credits (1 lead).
    label_leads_use_credits_enhance_summary_singular:
        'Enhancing **1** selected lead will use **up to %1$s** credit.',

    // label_leads_use_credits_failed_not_charged — Confirm modal block 3: note about failed enrichments (index credits confirm).
    label_leads_use_credits_failed_not_charged: 'Failed enrichments are not charged.',

    // label_leads_use_credits_remaining_balance — Confirm modal block 3: projected balance; %1$s = balance after success (Markdown bold).
    label_leads_use_credits_remaining_balance:
        'Remaining balance if all enrich successfully: **%1$s** credits',

    // error_leads_valid_origin_required — Preview: validation error when origin/radius/filters invalid before prospecting (index).
    error_leads_valid_origin_required: 'Select a valid origin before running prospecting.',

    // action_leads_view_enhancement_results — Lead Pop result primary button when enrichment completes in modal (GameResult; leadPopLiterals result.viewProspectingResults).
    action_leads_view_enhancement_results: 'View prospecting results',
};

const splitCamelCase = (value = '') =>
    value
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .split(' ')
        .filter(Boolean);

const humanizeWord = (word = '') => WORD_OVERRIDES[word] || word.toLowerCase();

const buildDebugLabel = (specKey) => {
    const words = splitCamelCase(specKey);
    if (!words.length) return specKey;

    return words
        .map((word, index) => {
            const normalizedWord = humanizeWord(word);
            if (!normalizedWord) return normalizedWord;
            if (normalizedWord === normalizedWord.toUpperCase()) return normalizedWord;
            if (index === 0) {
                return normalizedWord.charAt(0).toUpperCase() + normalizedWord.slice(1);
            }
            return normalizedWord;
        })
        .join(' ');
};

export const LEADS_DEBUG_LITERALS = Object.fromEntries(
    Object.entries(LEADS_LITERALS).map(([specKey, literalKey]) => [
        literalKey,
        SENTENCE_OVERRIDES[literalKey] ?? buildDebugLabel(specKey),
    ]),
);
